<template>
  <div>
    <v-row>
      <v-col cols="12" class="d-flex justify-end" style="height: 54px;">
        <div>
          <v-btn
            class="text-capitalize button-bold"
            t-data="org-name"
            color="secondaryTextColor"
            style="letter-spacing: 0.56px;border: 0.5px solid var(--secondary-text-color, #797B86);"
            depressed
            outlined
          >
            <v-img
              aspect-ratio="1"
              max-height="18"
              max-width="18"
              min-height="18"
              min-width="18"
              src="/images/hospital-gray-logo.png"
              class="mr-3"
            ></v-img>
            {{ getOrgNameByLang() }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="py-4">
        <h4 class="mt-0" t-data="info-title">
          {{ contentObject.title }}
        </h4>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        class="body-regular secondaryTextColor--text pt-0 pb-4"
        t-data="publish-date"
      >
        {{
          getDateRangeText(
            dataObject.period_start_date,
            dataObject.period_end_date
          )
        }}
      </v-col>
    </v-row>
    <v-row class="pb-4"  v-if="!isGroupPackage">
      <v-col cols="6" class="align-end d-flex justify-start align-center py-0">
        <h6 class="primary500Color--text" t-data="discount-price">
          {{
            calDiscountPrice(
              dataObject.discount,
              dataObject.discount_type,
              dataObject.full_price
            ) + ' Baht'
          }}
        </h6>
        <div
          class="sales-price-preview-discount-price body-regular ml-2"
          t-data="full-price"
          v-if="dataObject.discount && dataObject.discount > 0"
        >
          {{ commaNumber(dataObject.full_price) + ' Baht' }}
        </div>
      </v-col>
      <v-col cols="6" class="d-flex justify-end align-center pa-0">
        <v-btn
          v-if="dataObject.available_status"
          class="white-text-button button-bold text-capitalize mr-3"
          t-data="buy-btn"
          color="#2E5696"
          style="letter-spacing: 0.0125em; max-width: 120px"
        >
          {{ buyBtnText }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" t-data="profile-image" class="py-0">
        <v-img :src="contentObject.thumbnail" max-height="501"></v-img>
      </v-col>
    </v-row>
    <sub-package-content
      v-if="isGroupPackage"
      :lang="lang"
      :channel="displayType.WEB"
      :sub-package-list="subPackageList"
      :available-status="dataObject.available_status"
    />
    <v-divider :class="{'mb-4': true, 'mt-4': !hasSubPackage}"></v-divider>
    <div
      class="content-detail body-regular primaryTextColor--text mt-2"
      t-data="description"
      v-html="contentObject.description"
    ></div>
    <div class="my-4 mx-6 d-flex justify-center">
      <v-btn
        v-if="dataObject.available_status"
        class="white-text-button button-bold text-capitalize"
        t-data="buy-btn"
        color="#2E5696"
        style="letter-spacing: 0.0125em; max-width: 120px"
      >
        {{ buyBtnText }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import SubPackageContent from '@/components/package/SubPackageContent'
import {
  calculateDiscountPrice,
  convertDateFullMonthDate,
  convertIntegerToCommaNumber
} from '@/helper/helper'
import {displayTypeEnum, packageTypeEnum} from '@/constants/package'

export default {
  name: 'WebsitePreviewContent',
  components: {
    SubPackageContent
  },
  props: {
    dataObject: {type: Object},
    orgs: {type: Array},
    lang: {type: String},
    packageType: {type: String},
    subPackageList: {type: Array}
  },
  computed: {
    isGroupPackage() {
      return this.packageType === packageTypeEnum.GROUP
    },
    hasSubPackage() {
      return this.subPackageList.length > 0
    },
    contentObject() {
      return this.dataObject.contents.filter(obj => {
        return obj.code === this.lang
      })[0]
    },
    buyBtnText() {
      return this.lang === 'en' ? 'Buy Package' : 'ซื้อแพ็กเกจ'
    },
    displayType: () => displayTypeEnum
  },
  methods: {
    getContentByLang(contents, lang, field) {
      const contentsInLang = contents.filter(c => c.code === lang)
      if (contentsInLang.length > 0) {
        return contentsInLang[0][field]
      }
      return ''
    },
    getOrgNameByLang() {
      const fieldName = this.lang === 'en' ? 'name' : 'name_th'
      const getName = o => o.hasOwnProperty(fieldName) ? o[fieldName] : ''
      return this.orgs.map(getName).join(', ')
   },
    dateFmt: date => convertDateFullMonthDate(date),
    getDateRangeText(startDate, endDate) {
      if (this.lang === 'th') {
        const startDateFmt = convertDateFullMonthDate(startDate, 'th')
        const endDateFmt = convertDateFullMonthDate(endDate, 'th')
        return `ตั้งแต่ ${startDateFmt} ถึง ${endDateFmt}`
      } else {
        const startDateFmt = convertDateFullMonthDate(startDate)
        const endDateFmt = convertDateFullMonthDate(endDate)
        return `From ${startDateFmt} to ${endDateFmt}`
      }
    },
    commaNumber: value => convertIntegerToCommaNumber(value),
    calDiscountPrice: (discount, discountType, fullPrice) =>
      calculateDiscountPrice(discount, discountType, fullPrice)
  }
}
</script>
<style lang="scss" scoped>
.card-title {
  line-height: 22px;
}
</style>
